<template>
  <Layout>
    <!-- start page title -->
    <PageHeader :title="title" :items="items" />
    <!-- end page title -->

    <div class="row">
<!--      <div class="col-xl-3">-->
<!--        <BranchStatsPanel />-->
<!--      </div>-->
      <!-- end col -->
      <div class="col-xl-12">
        <div class="card">
          <div class="card-body">
            <h4 class="card-title mb-4">Loan Amortization Schedule</h4>
            <!-- Supposed Form -->
            <div class="form-body">
              <LoanAmortizationScheduleTable />
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- end row -->
  </Layout>
</template>

<script>
/**
 * Create Bank Component
 */


import Layout from "../../router/layouts/main";
import PageHeader from "../../components/AppComponents/page-header";
import LoanAmortizationScheduleTable from "../../components/Kleyton/Tables/Loan/LoanAmortizationScheduleTable";

export default {
  page: {
    title: "View Loans",
    meta: [{ name: "View Loans", content: window.__env.app.description }]
  },
  components: {
    LoanAmortizationScheduleTable,
    Layout,
    PageHeader
  },
  data() {
    return {
      createBankFormBody: {
        source: "web"
      },
      title: "Loan Amortization Schedule",

      items: [
        {
          text: "Loan",
          href: "/"
        },
        {
          text: "Amortization Schedule",
          active: true
        }
      ]
    };
  },
  methods: {}
};
</script>
